<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="分类名称:" prop="cate_name">
                <Input type="text" v-model="formData.cate_name"></Input>
            </FormItem>
            <FormItem label="缩略图：" prop="thumb">
                <ImgUpload ref="upImg" :action="upload.actionUrl" :num="1" @setThumbUrl="setThumbUrl"></ImgUpload>
            </FormItem>
             <FormItem label="排序:" prop="sort">
                <Input type="text"  v-model="formData.sort"></Input>
            </FormItem>
            <FormItem label="首页显示:" prop="is_main_show">
                <RadioGroup v-model="formData.is_main_show">
                    <Radio label="1">
                        <span>是</span>
                    </Radio>
                    <Radio label="2">
                        <span>否</span>
                    </Radio>
                </RadioGroup>

            </FormItem>
            <FormItem label="类型:" prop="type">
                <RadioGroup v-model="formData.type">
                    <Radio label="1">
                        <span>广告</span>
                    </Radio>
                    <Radio label="2">
                        <span>产品与服务</span>
                    </Radio>
                    <Radio label="3">
                        <span>增值服务</span>
                    </Radio>
                </RadioGroup>

            </FormItem>
            <FormItem label="状态" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>显示</span>
                    </Radio>
                    <Radio label="2">
                        <span>隐藏</span>
                    </Radio>
                </RadioGroup>

            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import ImgUpload from "../common/upload"
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                upload:{//图片上传组
                    actionUrl:this.config.urlArray.uploadCateThumb,//上传图片接口
                },
                formData: {//表单数据
                    cate_name: '',
                    thumb:'',
                    is_main_show:'1',
                    type:'1',
                    status:'1',
                    sort: '100'
                },
                ruleCustom: {//验证
                    cate_name: [
                        {required: true, message: '分类名称不能为空', trigger: 'blur' },
                    ],

                    thumb: [
                        {required: true, message: '分类缩略图不能为空', trigger: 'blur' },
                    ],
                    is_main_show: [
                        {required: true, message: '必须选择是否在首页显示', trigger: 'change' },
                    ],
                    type: [
                        {required: true, message: '必须选择分类类型', trigger: 'change' },
                    ],
                    status: [
                        {required: true, message: '必须选择分类状态', trigger: 'change' },
                    ],
                    sort: [
                        {required: true, message: '排序不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^[0-9]\d*$/i, message:'排序必须为不小于零的整数', trigger:'blur'},
                    ],
                },
            }
        },
        components: {
            ImgUpload
        },
        methods: {
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.cate_name = this.editFormData.cate_name.toString();
                        this.formData.thumb = this.editFormData.thumb.toString();
                        this.formData.is_main_show = this.editFormData.is_main_show.toString();
                        this.formData.type = this.editFormData.type.toString();
                        this.formData.status = this.editFormData.status.toString();
                        this.formData.sort = this.editFormData.sort.toString();
                        this.$nextTick(() => {
                                let hasUpload = [{
                                    status:'finished',
                                    response:{data:{path:this.editFormData.thumb}}
                                }]
                                this.$refs.upImg.setHasUpload(hasUpload)//为上传组件付默认值
                        })
                    }
                    this.title = this.type == 1?'添加分类':'编辑分类'
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                        }

                        this.axios.post(this.config.urlArray.cateStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            setThumbUrl(url){//获取图片上传后的路径
                this.formData.thumb = url;
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.upImg.clearImg()//清除已上传的图片
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
